const mobileNumberRegex = /^[1234567890\-\(\)\+ ]{7,20}$/; // eslint-disable-line no-useless-escape

const validSSNRegex = /^.{3}-.{2}-.{4}$/; // eslint-disable-line no-useless-escape

const validBankAcctRegex = /^[a-zA-Z0-9\s]*$/; // eslint-disable-line no-useless-escape

const validWebsiteRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/; // eslint-disable-line no-useless-escape, max-len

const validYearRegex = /^(20|21)\d{2}$/;

const validEnglishOnlyFieldRegex = /^[a-zA-Z0-9_\-\s.]+$/;

export {
    mobileNumberRegex,
    validBankAcctRegex,
    validSSNRegex,
    validWebsiteRegex,
    validYearRegex,
    validEnglishOnlyFieldRegex
};
